import ServicePage from "@/components/ServicePage";

const Operations = () => (
  <ServicePage
    pillar="CAPABILITY 04"
    title="Operations & Resilience"
    ctaLabel="Discuss an Operations & Resilience challenge"
    canonical="/services/operations"
    seoTitle="Operations & Resilience | Skandor Technologies"
    seoDescription="Strengthen the systems, processes and operating model required to scale and perform — including ERP, planning, fulfillment and supply-chain where relevant."
    headline="The systems, processes and operating model required to scale and perform."
    lede="Operations & Resilience is where strategy meets the operating reality of the business. We strengthen the systems, processes and operating model — including ERP, planning, fulfillment and supply-chain where they are the constraint — so growth compounds instead of fragmenting."
    includes={[
      "Operating diagnostic across the parts of the business that need to move together",
      "Target operating model and change roadmap",
      "Systems posture: ERP, planning and fulfillment — fit for scale, fit for change, or fit to retire",
      "Supplier and supply-chain resilience view where relevant to the transformation",
      "Handover playbook so your team runs the improvement",
    ]}
    deliverables={[
      "Target operating model and change roadmap",
      "Systems and process improvements delivered without stopping the business",
      "Measurable outcome and handover to your team",
    ]}
    stages={[
      { n: "01", title: "Align", body: "Define the transformation ambition and what winning looks like." },
      { n: "04", title: "Launch & Scale", body: "Harden the operating model as the business grows into it." },
      { n: "05", title: "Optimize & Reinvent", body: "Measure outcomes and identify the next constraint to remove." },
    ]}
  />
);

export default Operations;
